import { WithWorkspaceId } from '~/types/common';
import { ProcessSchedule } from '~/types/resources';
import { dashboardProcessApi } from '~/utils/api';

export const createSchedule = async ({
  workspaceId,
  processId,
  schedule,
}: {
  processId: string;
  schedule: Omit<ProcessSchedule, 'id'> & { id: undefined };
} & WithWorkspaceId) =>
  dashboardProcessApi.post<ProcessSchedule>(
    `/workspaces/${workspaceId}/processes/${processId}/schedules`,
    {
      ...schedule,
    },
  );

export const getSchedulesByProcessId = async ({
  workspaceId,
  processId,
}: { processId: string } & WithWorkspaceId) =>
  dashboardProcessApi.get<ProcessSchedule[]>(
    `/workspaces/${workspaceId}/processes/${processId}/schedules`,
  );

export const listWorkspaceSchedules = async ({ workspaceId }: WithWorkspaceId) =>
  dashboardProcessApi.get<ProcessSchedule[]>(`/workspaces/${workspaceId}/schedules`);

export const deleteRobotSchedule = async ({
  workspaceId,
  processId,
  scheduleId,
}: { processId: string; scheduleId: string } & WithWorkspaceId) =>
  dashboardProcessApi.delete<number>(
    `/workspaces/${workspaceId}/processes/${processId}/schedules/${scheduleId}`,
  );

export const editRobotSchedule = async ({
  workspaceId,
  processId,
  scheduleId,
  schedule,
}: {
  processId: string;
  scheduleId: string;
  schedule: ProcessSchedule;
} & WithWorkspaceId) =>
  dashboardProcessApi.put<ProcessSchedule>(
    `/workspaces/${workspaceId}/processes/${processId}/schedules/${scheduleId}`,
    {
      ...schedule,
    },
  );
